<template>
  <component
    :is="inputComponent"
    v-model="modelValue"
    :always-negative
    :always-positive
    :silent
    :unformatted="isGridBunch"
    placeholder="Enter a number"
  >
    <template v-if="trailCurrency" #trailing>
      {{ currency }}
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed, ComputedRef, inject, ref } from 'vue'

import type { TransactionSettings } from '@types'

import { NEGATIVE_RULES, POSITIVE_RULES } from '@/helpers/validate'

import { TransactionAmountRule } from '@/entities/transactions/utils/enums'

import { UIInputNumber, UIInputPercent } from '@ui/fields'

type Props = {
  settings?: TransactionSettings['entries'][number]['amount']
  trailCurrency?: boolean
}

const props = defineProps<Props>()

const modelValue = defineModel<number | null>()

const currency = inject<ComputedRef<string>>('currency')
const isSavedTransaction = inject('isSavedTransaction', ref(false))
const isGridBunch = inject<boolean>('isGridBunch', false)

const silent = computed(() => !isSavedTransaction.value)

const inputComponent = computed(() =>
  props.settings?.rule === TransactionAmountRule.PERCENT ? UIInputPercent : UIInputNumber,
)

const alwaysNegative = computed(() => {
  const rule = props.settings?.rule
  return !!rule && NEGATIVE_RULES.includes(rule)
})

const alwaysPositive = computed(() => {
  const rule = props.settings?.rule
  return !!rule && POSITIVE_RULES.includes(rule)
})
</script>
